const userSummary = (state = null, action) => {
  if (action.type === "SET_SUMMARY") {
    return action.payload;
  } else {
    return state;
  }
};

export default userSummary;
